/* eslint sort-keys: "error" */
export default {
    Experiments: {
        Example: {
            Dimension: {
                Name: 'Example CTA Button',
                VariantControl: 'No Button',
                VariantTest: 'Button'
            },
            Name: 'Example SpendSmart A/B Experiment'
        }
    },
    FeatureFlagPropertyNames: {
        PlatformCommunications: {
            DaysToShowAfterRelease: 'daysToShowAfterRelease',
            ReleaseDate: 'releaseDate'
        }
    },
    FeatureFlags: {
        AgreeAndLinkExactDateTime: 'SpendSmart Agree & Link Account Exact DateTime',
        CategoryCardsRefreshPhase1: 'SpendSmart Category Cards Refresh Phase 1',
        Example: 'Example Feature Flag',
        ManageEmailPreferences: 'SpendSmart Manage Email Preferences',
        PlatformCommunications: 'SpendSmart Platform Communications',
        TransactionsContextualRules: 'SpendSmart Transactions Contextual Rules',
        TransfersInTransfersOutTransactionSummary: 'SpendSmart Transfers In/Transfers Out Transaction Summary'
    }
};
